import LoadSpinner from 'components/LoadSpinner/styled';

export default LoadSpinner;
